import React from "react"
import { Card, CardTitle } from "../../components/Card"
import { HeaderContent } from "../../components/Header"
import "./styles.scss"

export const AssistanceDetailsScreen = ({
  assistanceUsers,
  assistanceDetails,
  assistanceDate,
  assistanceTechnician,
}) => {

  return (
    <Card className="no-border">
      <div className="evidences-details-container" style={{ width: "100%" }}>
        <HeaderContent>
          <CardTitle title="Relatório de Atendimento" />
        </HeaderContent>
        <div className="assistance-users-container">
          {assistanceTechnician?.name && assistanceDate && (
            <div className="assistance-technician-details">
              <h4>Técnico: {assistanceTechnician?.name}</h4>
              <h5>Data: {assistanceDate}</h5>
            </div>
          )}
          <h4 className="assistance-container-title">Produtores</h4>
          <div className="assistance-users-list">
            <ul>
              {assistanceUsers &&
                Array.isArray(assistanceUsers) ?
                [...new Set([...assistanceUsers
                  .filter(item => item.userFarmer[0])
                  .map(item => `${item.userFarmer[0]?.name} - ${item.userFarmer[0]?.email}`)])]
                .map((item) => <li>{item}</li>) : <li>{`${assistanceUsers?.name} - ${assistanceUsers?.email}`}</li>}
            </ul>
          </div>
        </div>
        <div className="assistance-questions-container">
          <div className="assistance-questions-table">
            <h4 className="assistance-container-title">Informações coletadas durante o atendimento</h4>
            <table>
              <tbody>
                {assistanceDetails &&
                  Array.isArray(assistanceDetails) &&
                  assistanceDetails.map((item, index) => (
                    <tr>
                      <td className={index % 2 !== 0 ? "white__line" : "td-questions"}>
                        {item?.title}
                      </td>
                      <td className={index % 2 !== 0 ? "white__line" : "td-questions"}>
                        {item?.value.indexOf("https://firebase") !== -1
                          ? item?.value
                              .split("|")
                              .map((image) => (
                                <img
                                  src={image}
                                  height={128}
                                  width={128}
                                  style={{ objectFit: "contain", marginRight: "8px" }}
                                />
                              ))
                          : item?.value.indexOf("|") === -1
                          ? item?.value
                          : item.value?.replaceAll("|", " | ")}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Card>
  )
}
